import NewStaticTable from "components/staticTable/NewStaticTable"
import Modal from "global/Modal/Modal"
import SimpleButton from "global/SimpleButton/SimpleButton"
import { useEffect, useState } from "react"
import { getAPI } from "services/CRUDServices"
import { ConsumeColumns } from "./column"
import SinglePayment from "../single-payment"
import { usePayment } from "../single-payment/usepayment"
import { getDay } from "tools/functions/Methods"
import { addEditUrls } from "services/api.enums"
import { FinancialCalculation } from "./type"
import SharePercentFooter from "../components/sahred-percent"

type ConsumerCreditProps = {
  open: boolean
  setOpen: (val: any) => void
  currentData: any
}

function ConsumerCredit({ open, setOpen, currentData }: ConsumerCreditProps) {
  const { handleSubmit, refId } = usePayment()
  const [tableData, setTabledata] = useState<any[]>([])
  const [sharePercentInfo, setSharePercentInfo] =
    useState<FinancialCalculation>()

  useEffect(() => {
    if (!open) return

    getAPI(
      `/customer-api/subsidiaryLedger/findByCredit/${currentData.id}`
    ).then((res) => {
      const data = res.data.payload.map((item) => ({
        ...item,
        createDateTime: getDay(item.createDateTime),
      }))
      setTabledata(data)
    })

    getAPI(addEditUrls.fetchSharePercentageFromCredit + currentData.id).then(
      (res) => {
        setSharePercentInfo({
          ...res.data.payload,
          usedCredit: currentData.usedCredit,
        })
      }
    )
  }, [open, currentData.id])

  return (
    <>
      <Modal
        visible={open}
        setVisible={setOpen}
        title='جزئیات اعتبار مصرفی'
        className='w-[30rem]'
      >
        <div className='mb-4'>
          <span>هاب: </span>
          <span className='font-semibold'>
            {currentData.creditRecipientHub?.name}
          </span>
        </div>

        <NewStaticTable
          maxHeight='35rem'
          data={tableData}
          THWrapper='whitespace-nowrap'
          column={ConsumeColumns}
          footer={
            <SharePercentFooter
              sharePercentInfo={sharePercentInfo}
              columnLength={ConsumeColumns.length}
            />
          }
        />

        <div className='btnForm mt-4 flex gap-2 justify-end'>
          <SimpleButton
            handelClick={() => setOpen({ ...open, inquirtAccount: false })}
            text='انصراف'
            className='text-tomato'
          />
          <SimpleButton
            type='submit'
            text='تایید و واریز'
            className='full-tomato-btn'
            disabled={tableData.length === 0}
            handelClick={() =>
              handleSubmit({
                ...currentData,
                pay: sharePercentInfo?.totalPayable,
              })
            }
          />
        </div>
      </Modal>

      <SinglePayment refId={refId} />
    </>
  )
}

export default ConsumerCredit

const data = [
  { id: 1, hub: "تهران", status: "پرداخت شده", account: "علی منحمدی" },
  { id: 2, hub: "مشهد", status: "پرداخت شده", account: "علی رضایی" },
]

// const mock = [
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
//   {
//     invoiceId: 54855,
//     amount: 990000,
//     orderCode: "order140401184553572",
//     orderId: null,
//     createDateTime: {
//       day: 18,
//       month: 1,
//       year: 1404,
//       hour: "11",
//       minute: "35",
//     },
//   },
//   {
//     invoiceId: 54358,
//     amount: 2995960,
//     orderCode: "order1403101154370",
//     orderId: null,
//     createDateTime: {
//       day: 11,
//       month: 10,
//       year: 1403,
//       hour: "11",
//       minute: "23",
//     },
//   },
// ]
